export const SOLD_LIST_REQUEST = "SOLD_LIST_REQUEST";
export const SOLD_LIST_SUCCESS = "SOLD_LIST_SUCCESS";
export const SOLD_LIST_FAIL = "SOLD_LIST_FAIL";